import React from "react";
import { Route } from "react-router-dom";
import { ListadoPostventa } from "./ListadoPostventa";
import { DahsboardMainScreen } from "./Dashboard/DahsboardMainScreen";
import { GarantiaMainScreen } from "./Dashboard/Garantia/GarantiaMainScreen";
import { MantenimientoMainScreen } from "./Dashboard/Mantenimiento/MantenimientoMainScreen";
import { ContactoMainScreen } from "./Dashboard/Contacto/ContactoMainScreen";
import { CotizacionesDashboardMainScreen } from "./Dashboard/Cotizaciones/CotizacionesDashboardMainScreen";
import { MontosGarantiaScreen } from "./Dashboard/Garantia/MontosGarantiaScreen";
import { ConfiguracionPaquetesScreen } from "./Dashboard/Mantenimiento/ConfiguracionPaquetesScreen";
import { ListadoPreciosMantenimientoScreen } from "./Dashboard/Mantenimiento/ListadoPreciosMantenimientoScreen";
import { MensajeriaGeneralScreen } from "./MensajeriaGeneral/MensajeriaGenerlaScreen";
import { GarantiaMenuScreen } from "./Dashboard/Garantia/GarantiaMenuScreen";
import ReporteRefaccionesDetalleCliente from "./ReporteRefacciones/ReporteRefaccionesDetalleCliente";
import ReporteRefaccionesDetalleFamilia from "./ReporteRefacciones/ReporteRefaccionesDetalleFamilia";
import ReporteRefaccionesDetalleVendedor from "./ReporteRefacciones/ReporteRefaccionesDetalleVendedor";
import ReporteRefaccionesBoceto from "./ReporteRefacciones/ReporteRefaccionesBoceto";
import VendedoresEquipScreen from "./ReporteRefacciones/Vendedores/VendedoresEquipScreen";
import MultiplicadorPiezasScreen from "./ReporteRefacciones/MultiplicadoresPiezas/MultiplicadorPiezasScreen";
import FamiliaRefaccionesMainScreen from "./ReporteRefacciones/FamiliaRefacciones/FamiliaRefaccionesMainScreen";
import { DashboardOTAbiertasScreen } from "./DashboardOrdenTrabajo/DashboardOTAbiertasScreen";
import { OrdenTrabajoAbiertaSucursalScreen } from "./DashboardOrdenTrabajo/OrdenTrabajoAbiertaSucursalScreen";

export const RutasPostventaScreen = () => {
  return (
    <div className="main-container">
      <Route path="/Postventa/Main" component={() => <ListadoPostventa />} />
      <Route
        path="/PostVenta/Dashboard"
        component={() => <DahsboardMainScreen />}
      />
      <Route
        path="/PostVenta/Garantia"
        component={() => <GarantiaMainScreen />}
      />
      <Route
        path="/PostVenta/GarantiaMenu"
        component={() => <GarantiaMenuScreen />}
      />
      <Route
        path="/PostVenta/ConfigurarMontos"
        component={() => <MontosGarantiaScreen />}
      />
      <Route
        path="/PostVenta/CotizacionesDashboard"
        component={() => <CotizacionesDashboardMainScreen />}
      />
      <Route
        path="/PostVenta/Mantenimiento"
        component={() => <MantenimientoMainScreen />}
      />
      <Route
        path="/PostVenta/Contacto"
        component={() => <ContactoMainScreen />}
      />
      <Route
        path="/PostVenta/ConfiguracionPaquetesMantenimiento"
        component={() => <ConfiguracionPaquetesScreen />}
      />
      <Route
        path="/PostVenta/ListadoPreciosMantenimiento"
        component={() => <ListadoPreciosMantenimientoScreen />}
      />
      <Route
        path="/PostVenta/MensajeriaGeneral"
        component={() => <MensajeriaGeneralScreen />}
      />
      <Route
        path="/PostVenta/ReporteRefacciones"
        component={() => <ReporteRefaccionesBoceto />}
      />
      <Route
        path="/PostVenta/ReporteRefaccionesDetalleFamilia"
        component={() => <ReporteRefaccionesDetalleFamilia />}
      />
      <Route
        path="/PostVenta/ReporteRefaccionesDetalleCliente"
        component={() => <ReporteRefaccionesDetalleCliente />}
      />
      <Route
        path="/PostVenta/ReporteRefaccionesDetalleVendedor"
        component={() => <ReporteRefaccionesDetalleVendedor />}
      />
      <Route
        path="/PostVenta/VendedoresEquip"
        component={() => <VendedoresEquipScreen />}
      />
      <Route
        path="/PostVenta/MultiplicadoresPiezas"
        component={() => <MultiplicadorPiezasScreen />}
      />
      <Route
        path="/PostVenta/FamiliaRefacciones"
        component={() => <FamiliaRefaccionesMainScreen />}
      />
      <Route
        path="/PostVenta/DashboardOTAbiertas"
        component={() => <DashboardOTAbiertasScreen />}
      />
      <Route
        path="/PostVenta/OrdenTrabajoAbiertaSucursal"
        component={() => <OrdenTrabajoAbiertaSucursalScreen />}
      />
    </div>
  );
};
